<div class="main-layout">
  <header>
    <app-header></app-header>
  </header>
  <main>
    <router-outlet></router-outlet>
    <app-loading-indicator></app-loading-indicator>
  </main>
  <footer>
    <app-footer></app-footer>
  </footer>
</div>
